"use client";

import { AssetList } from "~/modules/assets/components/AssetList";
import { DEFAULT_ASSET_LIST_QUERY } from "~/modules/assets/consts";
import { AssetColumns } from "~/modules/assets/types";
import { FilterOperators, SortDirections } from "~/modules/filters/types";
import { ReferenceData } from "~/modules/reference_data/types";
import { AssetTableRowData } from "~/modules/assets/components/AssetTable/types";
import { ASSET_NAME_AND_TICKER_COLUMN_NON_EXPANDABLE } from "~/modules/assets/components/AssetTable/columns/AssetName";
import { ColumnMetadata } from "~/components/DataGrid";
import { getAssetTableColumnByCatalogSlug } from "../../components/CatalogAssetsTable/getAssetTableColumnByCatalogSlug";
import { CatalogReferenceDataSlugs } from "../../types";

// // // //

export function ReferenceAssets(props: { reference: ReferenceData }) {
    const { reference } = props;

    const columns: ColumnMetadata<AssetTableRowData, AssetColumns>[] = [
        ASSET_NAME_AND_TICKER_COLUMN_NON_EXPANDABLE,
        ...getAssetTableColumnByCatalogSlug(
            reference.slug as CatalogReferenceDataSlugs,
        ),
    ];

    return (
        <AssetList
            fixedHeader={true}
            fixedHeaderClassName="top-0"
            bordered={false}
            enableExport={false}
            enableApiTools={false}
            enableBasicSearch={false}
            enableProSearch={false}
            includeAdditionalNetworksRow={false}
            initialState={{
                results: [],
                sort: {
                    field: AssetColumns.name,
                    direction: SortDirections.asc,
                },
                pagination: {
                    page: 1,
                    perPage: 25,
                    pageCount: 1,
                    resultCount: 10,
                },
            }}
            assetsQuery={{
                ...DEFAULT_ASSET_LIST_QUERY,
                filter: {
                    operator: FilterOperators.And,
                    filters: [
                        {
                            field: AssetColumns.tokenCount,
                            operator: FilterOperators.GreaterThan,
                            value: 0,
                        },
                        {
                            field: reference.asset_table_column_name,
                            operator: FilterOperators.IsNotNull,
                            value: null,
                        },
                    ],
                },
                sort: {
                    field: AssetColumns.name,
                    direction: SortDirections.asc,
                },
                pagination: {
                    page: 1,
                    perPage: 25,
                },
            }}
            filterMetadata={[]}
            title="Assets"
            analyticsTableName="reference-data-assets"
            columns={columns}
        />
    );
}
